import { useEffect }  from 'react';
import { ImgUtilService } from '../../../../../shared/src/services/util/img-util.service';

export const usePreloadFirstBanner = (
    setFirstImgPreloaded,
    bannersList,
) => {
    // preload firs banner image
    useEffect(() => {
        setFirstImgPreloaded(false);

        if (Array.isArray(bannersList) && bannersList.length) {
            ImgUtilService.preloadImg(
                bannersList[0].content.image,
                () => { setFirstImgPreloaded(true); },
            );
        }

    }, [bannersList]);
};
